'use client';
import { useState, useEffect } from 'react';

// N.B. These values are based on styles/breakpoints.scss
// If you change these, also update the breakpoints in the styles file
export default function useMediaQuery() {
  const [breakpoint100, setBreakpoint100] = useState(false);
  const [breakpoint200, setBreakpoint200] = useState(false);
  const [breakpoint300, setBreakpoint300] = useState(false);
  const [breakpoint400, setBreakpoint400] = useState(false);

  useEffect(() => {
    const mq100 = window.matchMedia('(max-width: 34em)');
    const mq200 = window.matchMedia('(max-width: 48em)');
    const mq300 = window.matchMedia('(max-width: 64em)');
    const mq400 = window.matchMedia('(max-width: 72em)');

    const update = () => {
      setBreakpoint100(mq100.matches);
      setBreakpoint200(mq200.matches);
      setBreakpoint300(mq300.matches);
      setBreakpoint400(mq400.matches);
    };

    update();

    mq100.addEventListener('change', update);
    mq200.addEventListener('change', update);
    mq300.addEventListener('change', update);
    mq400.addEventListener('change', update);

    return () => {
      mq100.removeEventListener('change', update);
      mq200.removeEventListener('change', update);
      mq300.removeEventListener('change', update);
      mq400.removeEventListener('change', update);
    };
  }, []);

  return {
    breakpoint100,
    breakpoint200,
    breakpoint300,
    breakpoint400
  };
}
